import React from 'react'
import {MdStore as SalesPointIcon} from 'react-icons/md'
import classnames from '@helpers/misc/classnames'
import {useTranslation} from 'next-i18next'

import useUserInfo from '../../hooks/useUserInfo.main'

import canViewPos from './canViewPos'
import {userMenuLinkStyle} from '.'

function AdminSalesPoinLink() {
  const {t} = useTranslation('website', {keyPrefix: 'layout.layouts.default.navbar.menu'})
  const {me} = useUserInfo()
  const canView = canViewPos(me)
  if (!canView) return null

  return (
    <a
      href="https://pos.getjusto.com"
      target="blank"
      className={classnames('flex flex-row space-x-3', userMenuLinkStyle)}>
      <SalesPointIcon size={20} />
      <span>{t('labelPointOfSale')}</span>
    </a>
  )
}

export default AdminSalesPoinLink
